// extracted by mini-css-extract-plugin
export default {"link":"Catalog_link__D5sQe","picture":"Catalog_picture__NKByg"};